export let toastQueue = Promise.resolve();

export function showSuccessToast()
{
    return showToast(document.getElementById('toast-success'));
}

export function showFailureToast()
{
    return showToast(document.getElementById('toast-failure'));
}

export function showToast(toastElement: HTMLElement)
{
    // Enqueue another toast task at the end of queued toasts
    toastQueue = toastQueue.then(() => buildToastTask()).then();

    // Return current queue
    return toastQueue;

    function buildToastTask()
    {
        return new Promise((resolve) => {
            // Trigger animation by adding active class
            toastElement.classList.add('active');

            // Duration of the animation is 1.6s
            setTimeout(removeToast, 1600);

            function removeToast()
            {
                // Remove active class so the animation can run again when triggered
                toastElement.classList.remove('active');

                // Small delay before resolving, to ensure the class is removed
                setTimeout(resolve, 100);
            }
        });
    }
}
